export var guardContext = function(key, result) {
    if (!result.hasContext) {
        throw new Error("The requested data is not been provided in the context (contextKey: ".concat(key, ")"));
    }
};
